import { EventDrivenStore } from '@core/store/eventDrivenStore';
import constants from '@core/utils/constants';

class DealsStore extends EventDrivenStore {
  constructor() {
    super('deals', {
      deals: [],
      currentDeal: null,
      currentDealDishes: [],
      loading: false,
      dishesLoading: false,
      error: null
    });

    console.log('[DealsStore] Setting up event listeners');

    // List loading
    this.on(constants.EVENTS.DEALS.LOADING, () => {
      this.state.loading = true;
      this.state.error = null;
    });

    this.on(constants.EVENTS.DEALS.LOADED, () => {
      this.state.loading = false;
    });

    this.on(constants.EVENTS.DEALS.LOAD_ERROR, (error) => {
      this.state.loading = false;
      this.state.error = error;
      this.state.deals = [];
    });

    // Detail and dishes loading
    this.on('deals.detail_loaded', (deal) => {
      this.state.currentDeal = deal;
      this.state.loading = false;
    });

    this.on('deals.dishes_loaded', (dishes) => {
      this.state.currentDealDishes = dishes;
      this.state.dishesLoading = false;
    });

    console.log('[DealsStore] Event listeners set up successfully');
  }
}

export default DealsStore;
